import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'formly-phone-input',
  template: `
    <mat-form-field
      appearance="outline"
      style="width: 100%">
      <mat-label>{{ props.label }}</mat-label>
      <input
        matInput
        [formControl]="formControl"
        [formlyAttributes]="field"
        [required]="props.required"
        mask="(000) 000-0000"
        [placeholder]="props.placeholder || ''"
        type="tel"
      />
      <mat-icon role="button" class="phone" matSuffix (click)="telCall()">phone</mat-icon>
      <mat-error *ngIf="formControl.invalid && formControl.touched">
        <formly-validation-message [field]="field"></formly-validation-message>
      </mat-error>
    </mat-form-field>
  `,
  styleUrls: ['./phone-input.type.scss'],
})
export class PhoneInputType extends FieldType<FieldTypeConfig> {
  telCall(): void {
    window.open(`tel:${this.formControl.value}`, '_self');
  }
}